const defaultConfig = {
	// ALB Base URL para nuestros servicios
	baseUrl: "https://b2c.sysone.com",
	infoauto: {
		// Proxy InfoAuto - Siempre usa la URL completa de producción
		proxyUrl: "https://b2c.sysone.com/infoauto",
	},
	analytics: {
		urlBase: "https://analytics.sysone.com/",
		siteId: 2,
		trackerUrl: "https://analytics.sysone.com/matomo.php",
		srcUrl: "https://analytics.sysone.com/matomo.js",
	},
};

let envConfig;

try {
	envConfig = JSON.parse(process.env.REACT_APP_B2C_WEB_CONF || "{}");
} catch (e) {
	console.warn("Error parsing REACT_APP_B2C_WEB_CONF:", e);
	envConfig = {};
}

const config = {
	baseUrl: defaultConfig.baseUrl,
	infoauto: {
		...defaultConfig.infoauto,
		...envConfig.infoauto,
	},
	analytics: {
		...defaultConfig.analytics,
		...envConfig.analytics,
	},
	sysone: {
		...envConfig.sysone,
	}
};

export default config;
